import type { FormError } from '@nuxt/ui'
import { z } from 'zod'

// Define a Nuxt 3 plugin
export default defineNuxtPlugin(() => {
    // Define the formSchemaParser function
    const formSchemaParser = (
        formRef: Ref<any>, // The form reference (can be any type that has setErrors method)
        schema: z.ZodType, // The zod schema for validation
        data: Object | Ref, // The data to validate, which can be an object or a Vue ref
        callback: Function // The callback function to call on successful validation
    ) => {
        // Parse the data using the schema, dereferencing if it's a ref
        const result = schema.safeParse(isRef(data) ? data.value : data)

        // If validation is successful, call the callback function
        if (result.success) {
            callback()
        } else {
            // If validation fails, collect the errors
            const errors: FormError[] = []
            result.error.issues.forEach(issue => {
                errors.push({
                    name: String(issue.path[0]), // Convert to string to ensure compatibility
                    message: issue.message, // The error message
                })
            })
            // Set the errors on the form reference using the new API
            formRef.value.setErrors(errors)
        }
    }

    // Provide the formSchemaParser function globally in the Nuxt app
    return {
        provide: {
            formSchemaParser
        }
    }
})